export default "__VITE_ASSET__Dj_PKs_s__"